import { render, staticRenderFns } from "./DistroCentreUsers.vue?vue&type=template&id=fbf7ff46&scoped=true"
import script from "./DistroCentreUsers.vue?vue&type=script&lang=js"
export * from "./DistroCentreUsers.vue?vue&type=script&lang=js"
import style0 from "./DistroCentreUsers.vue?vue&type=style&index=0&id=fbf7ff46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf7ff46",
  null
  
)

export default component.exports